import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import { PrivateRoute, NotFound } from '../public';
import { Permission } from '../../types/Auth';

import StackListContainer from './StackListContainer';
import StackDetailContainer from './StackDetailContainer';

const Stack: React.FC = (): React.ReactElement => {
    const routeMatch = useRouteMatch();
    return (
        <Switch>
            <PrivateRoute
                exact
                path={routeMatch.path}
                comp={StackListContainer}
                perm={Permission.STACK_LIST_SECTION_VIEW}
            />
            <PrivateRoute
                path={`${routeMatch.path}/detail/:stackId`}
                comp={StackDetailContainer}
                perm={Permission.STACK_DETAIL_SECTION_VIEW}
            />
            <Route path="*" component={NotFound} />
        </Switch>
    );
};

export default Stack;
